import { render } from "./ManagersView.vue?vue&type=template&id=d3d837cc"
import script from "./ManagersView.vue?vue&type=script&lang=js"
export * from "./ManagersView.vue?vue&type=script&lang=js"

import "./ManagersView.vue?vue&type=style&index=0&id=d3d837cc&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__